module.exports = "/images/maori.svg?fbff108d6836880e52f3207201afa59f";